module.exports = __webpack_public_path__ + "static/img/5.eb15658.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/sp/5.png
// module id = qzu4
// module chunks = 0